module.exports = __webpack_public_path__ + "img/percent-01.a2cfb50d.svg";